const moyenneValueGetter = (params) => {
  let aptitudes = params.data.resultats?.aptitudes;
  let total = 0;
  aptitudes?.forEach((apt) => (total += Number(apt.score_percent)));
  let nbItems = aptitudes?.length ? aptitudes?.length : 1;
  return Math.round(total / nbItems) ? Math.round(total / nbItems) : null;
};

export default moyenneValueGetter;
